module.exports = __webpack_public_path__ + "static/img/dialog1.f1fa659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog1.jpg
// module id = yWPK
// module chunks = 160